module.exports = __webpack_public_path__ + "static/media/kids_09.326f4b40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_09.jpg
// module id = 5865
// module chunks = 0